import { useEffect } from 'react'

const FOCUSABLE = 'input:not([disabled]), button:not([disabled]), a[href]'

// Keyboard behaviour of a modal dialog: focus lands inside it on open, Tab
// stays in it, Escape calls `onEscape`. Returns the dialog's onKeyDown.
export default function useDialogKeys(root, onEscape) {
  useEffect(() => {
    root.current?.querySelector(FOCUSABLE)?.focus()
  }, [root])

  return (event) => {
    if (event.key === 'Escape') {
      onEscape()
      return
    }
    if (event.key !== 'Tab') return
    const items = [...root.current.querySelectorAll(FOCUSABLE)]
    const first = items[0]
    const last = items.at(-1)
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }
}
